import dayjs from 'dayjs';

/**
 * 差分が何分か計算して文字列を返す
 * @param targetDate Dateオブジェクト
 * @param compareType 過去との比較か、未来との比較か
 */
export const calcDiffTimeFromNow = (
  targetDate: Date,
  compareType: 'past' | 'future'
) => {
  const now = dayjs();
  const dateFrom = dayjs(String(targetDate));
  if (compareType === 'past') {
    // 過去との差分
    if (now.diff(dateFrom, 'second') < 60) {
      return `${now.diff(dateFrom, 'second')}秒`;
    } else if (now.diff(dateFrom, 'minute') < 60) {
      return `${now.diff(dateFrom, 'minute')}分`;
    } else if (now.diff(dateFrom, 'hour') < 60) {
      return `${now.diff(dateFrom, 'hour')}時間`;
    } else if (now.diff(dateFrom, 'day') < 31) {
      return `${now.diff(dateFrom, 'day')}日`;
    } else {
      return now;
    }
  } else {
    // 未来との差分
    if (dateFrom.diff(now, 'second') < 0) {
      return '-1';
    } else if (dateFrom.diff(now, 'second') < 60) {
      return `${dateFrom.diff(now, 'second')}秒`;
    } else if (dateFrom.diff(now, 'minute') < 60) {
      return `${dateFrom.diff(now, 'minute')}分`;
    } else if (dateFrom.diff(now, 'hour') < 60) {
      return `${dateFrom.diff(now, 'hour')}時間`;
    } else if (dateFrom.diff(now, 'day') < 31) {
      return `${dateFrom.diff(now, 'day')}日`;
    } else {
      return now;
    }
  }
};

/**
 * 差分（origin - target）が何分か計算して文字列を返す
 * @param targetDate Dateオブジェクト
 * @param compareType 過去との比較か、未来との比較か
 */
export const calcDiffTime = (targetDate: Date, originDate: Date) => {
  const diffTimeMiliSec = originDate.getTime() - targetDate.getTime();

  let returnTxt = '';
  if (diffTimeMiliSec >= 1000 * 60 * 60 * 24) {
    const day = Math.floor(diffTimeMiliSec / (1000 * 60 * 60 * 24));
    if (day > 0) {
      returnTxt += `${day}日`;
    }
  }
  if (diffTimeMiliSec >= 1000 * 60 * 60) {
    const hour = Math.floor(diffTimeMiliSec / (1000 * 60 * 60)) % 24;
    if (hour > 0) {
      returnTxt += `${hour}時間`;
    }
  }
  if (diffTimeMiliSec >= 1000 * 60) {
    const min = Math.floor(diffTimeMiliSec / (1000 * 60)) % 60;
    if (min > 0) {
      returnTxt += `${min}分`;
    }
  }
  if (diffTimeMiliSec >= 1000) {
    const sec = Math.floor(diffTimeMiliSec / 1000) % 60;
    if (sec > 0) {
      returnTxt += `${sec}秒`;
    }
  }

  return returnTxt;
};

/**
 * ルームが期限切れかどうか判定
 * @param createdAt ルームの作成日
 * @param expirationDate ルームの有効期限（単位：日）
 */
export const isExpired = (createdAt: Date, expirationDate: number) => {
  const dt = createdAt;
  dt.setDate(dt.getDate() + expirationDate);
  const diff = calcDiffTimeFromNow(dt, 'future');
  return diff === '-1';
};
